module.exports = __webpack_public_path__ + "static/media/rga_linz.0d475446.jpeg";